import React from 'react'

import Base from '../_Base'

const ComingSoon = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path
      d="M12,2 C17.5228475,2 22,6.4771525 22,12 C22,17.5228475 17.5228475,22 12,22 C6.4771525,22 2,17.5228475 2,12 C2,6.4771525 6.4771525,2 12,2 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C16.418278,20 20,16.418278 20,12 C20,7.581722 16.418278,4 12,4 Z M12,6 C12.5522847,6 13,6.44783689 13,7.00027168 L13,11.5845872 L15.7071068,14.2924294 C16.0976311,14.6830598 16.0976311,15.3163968 15.7071068,15.7070272 C15.3165825,16.0976576 14.6834175,16.0976576 14.2928932,15.7070272 L11,12.4132394 L11,7.00027168 C11,6.44783689 11.4477153,6 12,6 Z"
      fillRule="evenodd"
    />
  </Base>
)

export default ComingSoon
